import axios from "axios";
import { API_BASE as API } from "@/config/api";

const RAZORPAY_SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

let scriptPromise;

export function loadRazorpayScript() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Razorpay is only available in the browser"));
  }

  if (window.Razorpay) {
    return Promise.resolve(true);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = RAZORPAY_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error("Failed to load Razorpay checkout"));
      document.body.appendChild(script);
    });
  }

  return scriptPromise;
}

export async function fetchRazorpayKeyId() {
  try {
    const { data } = await axios.get(`${API}/payments/config`);
    if (data.key_id) return data.key_id;
  } catch {
    // fall through to env fallback
  }
  return process.env.REACT_APP_RAZORPAY_KEY_ID || "";
}

export async function openRazorpayCheckout({
  key,
  orderId,
  amount,
  currency = "INR",
  name = "Petal Pookie",
  description = "Gift store order",
  prefill = {},
  onSuccess,
  onDismiss,
  onFailure,
}) {
  await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const options = {
      key,
      currency,
      name,
      description,
      order_id: orderId,
      prefill,
      theme: { color: "#4a5240" },
      handler: async (response) => {
        try {
          await onSuccess?.(response);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      },
      modal: {
        ondismiss() {
          onDismiss?.();
          reject(new Error("Payment cancelled"));
        },
      },
    };

    // When order_id is set, Razorpay uses the order amount — only pass amount as fallback.
    if (!orderId && amount) {
      options.amount = amount;
    }

    const razorpay = new window.Razorpay(options);

    razorpay.on("payment.failed", (response) => {
      onFailure?.(response);
      reject(new Error(response?.error?.description || "Payment failed"));
    });

    razorpay.open();
  });
}

export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || "";
